import { render, staticRenderFns } from "./CountriesSort.vue?vue&type=template&id=7dc1ae08&"
import script from "./CountriesSort.vue?vue&type=script&lang=js&"
export * from "./CountriesSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports